import { render, staticRenderFns } from "./ActivationCancel.vue?vue&type=template&id=59d95e61&scoped=true"
import script from "./ActivationCancel.vue?vue&type=script&lang=js"
export * from "./ActivationCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d95e61",
  null
  
)

export default component.exports